module.exports = __webpack_public_path__ + "img/icon-asset-pv.862ff7cc.png";